import React, { useEffect, useState } from 'react';
import Button from '@legacy-vfuk/core-button';
import { graphql, useStaticQuery } from 'gatsby';
import { GlobalFloatingPillWrapper } from './styles/GlobalFloatingPill.styles';
import fireButtonAndLinkClicksEvent from '../../helpers/fireButtonAndLinkClicksEvent';
import {
  AllContentfulGlobalFloatingPill,
  ContentfulGlobalFloatingPill,
  GlobalFloatingPillProps,
} from './types/GlobalFloatingPill.types';

const queryGlobalFloatingPill = graphql`
  {
    allContentfulGlobalFloatingPill {
      nodes {
        node_locale
        pillText
        pillUrl
        iconRef
      }
    }
  }
`;

const GlobalFloatingPill = ({
  firstLanguageLocalCode,
  secondLanguageUrlPrefix,
  isSecondLanguageOnUrl,
}: GlobalFloatingPillProps) => {
  const data = useStaticQuery<{
    allContentfulGlobalFloatingPill: AllContentfulGlobalFloatingPill;
  }>(queryGlobalFloatingPill);

  if (!data.allContentfulGlobalFloatingPill?.nodes.length) {
    return null;
  }

  const { nodes } = data.allContentfulGlobalFloatingPill;
  const firstLanguageGlobalFloatingPill = nodes.find(
    node => node.node_locale.slice(0, 2) === firstLanguageLocalCode
  );
  const secondLanguageGlobalFloatingPill = nodes.find(
    node => node.node_locale.slice(0, 2) === secondLanguageUrlPrefix
  );

  let usedLanguageGlobalFloatingPill = {} as ContentfulGlobalFloatingPill;
  if (isSecondLanguageOnUrl && secondLanguageGlobalFloatingPill) {
    usedLanguageGlobalFloatingPill = secondLanguageGlobalFloatingPill;
  } else {
    usedLanguageGlobalFloatingPill =
      firstLanguageGlobalFloatingPill as ContentfulGlobalFloatingPill;
  }

  const { pillText, pillUrl, iconRef } = usedLanguageGlobalFloatingPill;

  const [isVisible, setIsVisible] = useState(true);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    if (typeof window !== 'undefined') {
      setIsMobile(window.innerWidth <= 768);

      const handleScroll = () => {
        const scrollTop = window.scrollY;
        const docHeight = document.body.scrollHeight;
        const winHeight = window.innerHeight;
        const scrollBottom = docHeight - (scrollTop + winHeight);

        if (isMobile) {
          setIsVisible(scrollBottom > 200);
        }
      };

      const handleResize = () => {
        setIsMobile(window.innerWidth <= 768);
      };

      window.addEventListener('scroll', handleScroll);
      window.addEventListener('resize', handleResize);

      return () => {
        window.removeEventListener('scroll', handleScroll);
        window.removeEventListener('resize', handleResize);
      };
    }
  }, [isMobile]);

  const onClickHandler = () => {
    fireButtonAndLinkClicksEvent({
      event_label: pillText,
      event_action: 'button click',
    });
  };

  if (isVisible) {
    return (
      <GlobalFloatingPillWrapper isSecondLanguageOnUrl={isSecondLanguageOnUrl}>
        <Button
          text={pillText}
          appearance="primary"
          href={pillUrl}
          icon={
            iconRef
              ? {
                  name: iconRef,
                  justify: 'left',
                }
              : undefined
          }
          onClick={onClickHandler}
        />
      </GlobalFloatingPillWrapper>
    );
  }
  return null;
};

export default GlobalFloatingPill;
